module.exports = __webpack_public_path__ + "img/545.7ea040af.gif";